import { getNetwork, getNoopNetwork } from '../src/getNetwork.ts';

export const network = getNetwork();

export const noopNetwork = getNoopNetwork();
